import StudentItem from './StudentItem';
import { StudentItemProps, StudentItemValueProps } from './types';

export type { StudentItemProps, StudentItemValueProps };
export default StudentItem;
